/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export const lowerCaseArray = arr => arr.map(x => x.toLowerCase());